import { render, staticRenderFns } from "./consultationService.vue?vue&type=template&id=2d1d4225&scoped=true&"
import script from "./consultationService.vue?vue&type=script&lang=js&"
export * from "./consultationService.vue?vue&type=script&lang=js&"
import style0 from "./consultationService.vue?vue&type=style&index=0&id=2d1d4225&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d4225",
  null
  
)

export default component.exports